import * as Yup from 'yup';

export const getBlogValidationSchema = () => {
  return Yup.object({
    post_title: Yup.string().required('Title is required'),
    post_title_en: Yup.string().required('Title (English) is required'),
    post_img: Yup.array()
      .of(
        Yup.mixed()
          .required('La imagen es requerida')
          .test('fileSize', 'El archivo es demasiado grande', value => {
            return value && value.size <= 15000000;
          })
          .test('fileType', 'El formato no es válido', value => {
            return value && ['image/jpeg', 'image/png'].includes(value.type);
          }),
      )
      .min(1, 'Debe subir al menos una imagen')
      .required('Se requiere al menos una imagen'),
    post_url: Yup.string().required('URL are required'),
    post_keywords: Yup.string().required('Keywords are required'),
    author_id: Yup.string().required('El autor es obligatorio'),
    post_date: Yup.date().required('Post date is required'),
    type_id: Yup.number().required('Post type is required'),
  });
};
